import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'inner', 'title', 'description', 'icon', 'actionContainer'];
var baseStyle = {
  container: {
    px: 4,
    py: 3
  },
  inner: {
    display: 'flex',
    flexGrow: 1,
    alignSelf: {
      md: 'center'
    }
  },
  title: {
    fontWeight: 'bold',
    fontSize: 'lg',
    lineHeight: 'base',
    mr: 2,
    letterSpacing: '-0.2px',
    display: 'block'
  },
  description: {
    letterSpacing: '-0.2px',
    display: 'block'
  },
  icon: {
    flexShrink: 0,
    mr: 3
  },
  actionContainer: {
    display: 'flex',
    flexShrink: 0,
    ml: {
      base: 0,
      md: 16
    },
    mt: {
      base: 6,
      md: '0.625rem'
    },
    mb: {
      base: 0,
      md: '0.625rem'
    }
  }
};
var sizes = {
  sm: {
    container: {
      p: 3
    }
  },
  md: {
    container: {
      px: {
        base: 5,
        md: 6
      },
      py: {
        base: 5,
        md: 6
      },
      borderRadius: '0.625rem'
    },
    icon: {
      w: '1.5rem',
      h: '1.5rem'
    }
  }
};
var colorSchemes = {
  blue: {
    container: {
      backgroundColor: 'blue.1130',
      borderColor: 'blue.600'
    },
    icon: {
      color: 'blue.600'
    }
  },
  red: {
    container: {
      backgroundColor: 'red.1050',
      borderColor: 'red.700'
    },
    icon: {
      color: 'red.700'
    }
  },
  green: {
    container: {
      backgroundColor: 'green.900',
      borderColor: '#34AA40'
    },
    icon: {
      color: '#34AA40'
    }
  },
  yellow: {
    container: {
      backgroundColor: 'yellow.900',
      borderColor: '#F5A623'
    },
    icon: {
      color: '#F5A623'
    }
  }
};
function variantSubtle(_) {
  return {
    container: {
      border: '2px'
    }
  };
}
function variantBottomAccent(_) {
  return {
    container: {
      pt: 2,
      borderTop: '4px solid'
    }
  };
}
function variantInline() {
  return {
    container: {
      border: 'none',
      px: {
        base: '1rem',
        md: '1rem'
      },
      py: {
        base: '0.625rem',
        md: '0.625rem'
      }
    },
    icon: {
      width: 5,
      height: 5,
      mt: '0.125rem'
    },
    inner: {
      flexGrow: 0
    },
    description: {
      mt: '.625rem'
    }
  };
}
var variants = {
  subtle: variantSubtle,
  'bottom-accent': variantBottomAccent,
  inline: variantInline
};
var defaultProps = {
  variant: 'subtle',
  status: 'info',
  size: 'md'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  colorSchemes,
  sizes,
  variants,
  defaultProps,
  compoundModifiers: [{
    variant: 'left-accent',
    size: 'md',
    style: {
      container: {
        borderLeft: '8px',
        pl: 4
      }
    }
  }, {
    variant: 'left-accent',
    size: 'sm',
    style: {
      container: {
        borderLeft: '8px',
        p: 3
      }
    }
  }, {
    variant: 'inline',
    size: 'md',
    style: {
      container: {
        pt: '10px',
        pb: '10px'
      }
    }
  }]
});